import { useState } from 'react';
import { useMutation } from "@apollo/client"
import { createNotify } from '../src/queries/notify.js'
import logo from '../src/Assets/img/logo1.png';
import './App.css';
import { toast } from 'react-toastify';
import Loader from "react-loader-spinner";



function App() {
  const [email, _email] = useState('')
  const [Error, setError] = useState('')
  const [showLoader, _showLoader] = useState(false)


  const [addRequest, { error, data, loading }] = useMutation(createNotify)
  const onSubmit = () => {
    if (email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) === null) {
      setError("Email is not Valid");
    }
    else {
      setError(null);
      addRequest({
        variables: {
          "data": { "email": email }
        },
      }).then(() => {
        toast.success("We've got your request, stay tuned!")
      }).catch(() => {
        toast.error("")
      })
      _email('')
    }

  }
  return (
    <div className="coming-soon">
      <div className="container">

        {loading ?
          <div className="loader-blog">
            <Loader
              type="Circles"
              color="#000"
              height={50}
              width={50}
            />
          </div>
          : <></>}
        <div className="main-data">
          <div className="main-logo">
            <a href="">
              <img src={logo} />
            </a>
          </div>
          <div className="center-data">
            <div className="coming-soon_title">
              <h2> The NEXT Generation Revolution In Trucking Is Here.</h2>
              <p className="coming-sub-title">Fleet Management for small & Medium Sized Enterprises created with fleet managers for fleet managers.</p>
            </div>
            <form className="coming-soon_form" onSubmit={(e) => { e.preventDefault() }}>
              <div className="Email_textfield">
                <input placeholder="Enter email address" type="text" value={email} required className="TextField__Input" onChange={(e) => _email(e.target.value)} />
                {Error && (
                  <p className="contactError">
                    {Error}
                  </p>
                )}
              </div>
              <button className="notify_btn" type="button" onClick={(e) => onSubmit()} >NOTIFY ME</button>
            </form>
          </div>
          <div className="copy-right">
            <p>Copyright 2021 by truckinX Inc. All rights reserved</p>
          </div>

        </div>
      </div>

    </div>
  );
}

export default App;
